import React from 'react';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '../StyledModal';

const API_URL = ['localhost', '127.0.0.1'].includes(window.location.hostname)
  ? 'http://127.0.0.1:8000/api'
  : 'https://eps.acces-editions.com/api';

function MyModalModifAccountPassword({ IsModalOpened, onCloseModal, account, adminToken }) {
  const [password, setPassword] = React.useState('');
  const [confirmationStep, setConfirmationStep] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    if (IsModalOpened) {
      setPassword('');
      setConfirmationStep(false);
      setIsSubmitting(false);
    }
  }, [IsModalOpened, account]);

  function closeModal(event) {
    if (isSubmitting) return;
    onCloseModal(event, 6);
  }

  function requestConfirmation() {
    if (!password) {
      NotificationManager.error('Saisissez un nouveau mot de passe.', '', 3000);
      return;
    }

    if (!adminToken) {
      NotificationManager.error('Votre session administrateur doit être renouvelée. Reconnectez-vous.', '', 4000);
      return;
    }

    setConfirmationStep(true);
  }

  async function updatePassword() {
    if (!account || !account.id_compte || !password || !adminToken || isSubmitting) return;

    const formData = new FormData();
    formData.append('id_compte', account.id_compte);
    formData.append('password', password);
    setIsSubmitting(true);

    try {
      const response = await axios.post(
        `${API_URL}/adminUpdateAccountPassword`,
        formData,
        { headers: { Authorization: `Bearer ${adminToken}` } }
      );

      if (response.status === 200 && response.data && response.data.message === 'OK') {
        NotificationManager.success('Mot de passe du compte modifié', '', 3000);
        setIsSubmitting(false);
        onCloseModal(true, 6);
        return;
      }

      NotificationManager.error(response.data?.data || 'Le mot de passe n’a pas pu être modifié.', '', 4000);
    } catch (error) {
      const message = error.response?.data?.message || 'Le mot de passe n’a pas pu être modifié.';
      NotificationManager.error(message, '', 4000);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Modal size="md" active={IsModalOpened} toggler={() => { return; }}>
      <ModalHeader toggler={() => closeModal(false)}>
        Modifier le mot de passe
      </ModalHeader>
      <ModalBody>
        {confirmationStep ? (
          <div className="ae-admin-password-confirmation">
            <span className="ae-admin-password-confirmation__icon"><FontAwesomeIcon icon={faKey} /></span>
            <p>Êtes-vous sûr de vouloir modifier le mot de passe de ce compte&nbsp;?</p>
            <strong>{account?.email || `Compte #${account?.id_compte || ''}`}</strong>
          </div>
        ) : (
          <div className="text-left">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="admin-account-password">Nouveau mot de passe</label>
            <input
              id="admin-account-password"
              className="w-full border border-inherit p-2 rounded"
              value={password}
              type="password"
              autoComplete="new-password"
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color="red"
          buttonType="link"
          onClick={(event) => confirmationStep ? setConfirmationStep(false) : closeModal(event)}
          ripple="dark"
          disabled={isSubmitting}
        >
          {confirmationStep ? 'Retour' : 'Fermer'}
        </Button>
        <Button
          color="green"
          onClick={() => confirmationStep ? updatePassword() : requestConfirmation()}
          ripple="light"
          disabled={isSubmitting}
        >
          {confirmationStep ? (isSubmitting ? 'Modification…' : 'Confirmer') : 'Valider'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default MyModalModifAccountPassword;
